import useRouter from '../composables/useRouter'
const BETE_TOKEN_KEY = 'bete-token'
const BETE_USER_KEY = 'bete-user'
const BETE_INTENT_KEY = 'bete-intent'

// Para onde a pessoa estava indo quando caiu na tela de login. Os links que a Bete manda no Google
// Chat sao deep links (`/<telefone>/analyze?mark=unknown`), e sem guardar o destino o login jogava
// todo mundo em `/analyze` — o clique se perdia e nao havia como saber o que ele ia fazer.
export const setIntent = (hash: string) => {
  if (hash && hash !== '#/') localStorage.setItem(BETE_INTENT_KEY, hash)
}

export const takeIntent = () => {
  const intent = localStorage.getItem(BETE_INTENT_KEY) || ''
  localStorage.removeItem(BETE_INTENT_KEY)
  return intent.replace(/^#/, '')
}

export const getToken = () => {
  return localStorage.getItem(BETE_TOKEN_KEY) || ''
}

export const delToken = () => {
  localStorage.removeItem(BETE_TOKEN_KEY)
}

export const setUser = (user: Object) => {
  localStorage.setItem(BETE_USER_KEY, JSON.stringify(user))
}

export const getUser = () => {
  return JSON.parse(localStorage.getItem(BETE_USER_KEY) || '{}')
}

export const delUser = () => {
  localStorage.removeItem(BETE_USER_KEY)
}

export const setToken = (token: string) => {
  localStorage.setItem(BETE_TOKEN_KEY, token)
}

export const http = async (input: RequestInfo | URL, init?: RequestInit) => {
  const token = getToken()
  if (!token && !['/auth/google/callback', '/login'].includes(input.toString())) {
    setIntent(window.location.hash)
    const router = useRouter()
    router.push('/')
    return { error: 'Logue novamente', data: {} }
  }
  init = init || {}
  init.headers = {
    'Content-Type': 'application/json; charset=UTF-8',
    'Authorization': `Bearer ${token}`,
    ...init.headers
  }
  const response = await fetch(input, init)
  if (response.ok) {
    return response.json().then((data) => {
      return { data }
    })
  } else if (response.status == 401) {
    delToken()
    delUser()
    setIntent(window.location.hash)
    const router = useRouter()
    router.push('/')
    return { error: 'Logue novamente', data: {} }
  } else {
    return response.json().then((data) => {
      return { error: data.message, data }
    })
  }
}